import createReactComponent from '../createReactComponent';
export default createReactComponent('square-letter-r', 'IconSquareLetterR', [
  [
    'path',
    {
      d: 'M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4', key: 'svg-1' }],
]);
